import { axiosService } from "network/axios";

export interface SupportChat {
  id: string | number;
  [key: string]: any;
}

export interface SupportChatDto {
  chat_id: string;
  topic: string;
  status: "open" | "closed" | string;
  created_by: string;
  assigned_manager_id: string;
  created_at: string;
  updated_at?: string;
  last_message: string;
  last_message_at: string;
  unread_count: string;
  title?: string;
  subject?: string;
  state?: string;
  is_closed?: boolean | number;
}

export interface SupportChatsMeta {
  page: number;
  perPage: number;
  total: number;
  lastPage: number;
}

export interface ListSupportChatsResponse {
  data: SupportChatDto[];
  meta: SupportChatsMeta;
}

export interface SupportMessageDto {
  message_id: string;
  chat_id: string;
  sender_id: string;
  body: string;
  attachments: string[];
  created_at: string;
}

export interface ListSupportMessagesResponse {
  data: SupportMessageDto[];
  meta?: any;
}

export type ListSupportMessagesParams = {
  page?: number;
  per_page?: number;
};

export interface CreateSupportChatPayload {
  topic: string;
  message: string;
  attachments?: string[];
  assigned_manager_id?: number;
  order_id?: number;
}

 export type ListSupportChatsParams = {
  page?: number;
  per_page?: number;
 };

export interface UnreadMessagesCountResponse {
  data: number;
}

export const  supportApi = {
  listChats: (params?: ListSupportChatsParams) =>
    axiosService.get<ListSupportChatsResponse>("/api/support/chats", { params }),

  createChat: (payload: CreateSupportChatPayload) =>
    axiosService.post<unknown>("/api/support/chats", payload),

  closeChat: (chatId: string | number) =>
    axiosService.post<unknown>(`/api/support/chats/${chatId}/close`, {}),

  listMessages: (chatId: string | number, params?: ListSupportMessagesParams) =>
    axiosService.get<ListSupportMessagesResponse>(
      `/api/support/chats/${chatId}/messages`,
      { params }
    ),

  sendMessage: (chatId: string | number, payload: any) =>
    axiosService.post<unknown>(`/api/support/chats/${chatId}/messages`, payload),

  markRead: (chatId: string | number, payload: any = {}) =>
    axiosService.post<unknown>(`/api/support/chats/${chatId}/read`, payload),

  assignManager: (chatId: string | number, managerId: number) =>
    axiosService.post<unknown>(`/api/support/chats/${chatId}/messages`, {
      assigned_manager_id: managerId,
    }),

  getUnreadCount: () =>
    axiosService.get<UnreadMessagesCountResponse>("/api/support/messages/unread-count"),
};
